<template>
  <div
    v-if="
      Object.keys(order_detail).length === 0 &&
      order_detail.constructor === Object
    "
  >
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <div v-if="loading == true">
        <v-progress-circular
          :size="30"
          :width="5"
          color="primary"
          indeterminate
          class="ma-3"
        ></v-progress-circular
        >Loading...
      </div>
      <div v-else>
        <h1 class="ma-3">error</h1>
      </div>
      <v-spacer />
    </v-toolbar>
  </div>
  <div v-else>
    <v-toolbar dense flat dark>
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="order_detail.order_type == 3"
        small
        depressed
        color="blue"
        class="white--text"
        style="border-radius: 10px"
        >Free</v-btn
      >
      <v-toolbar-title
        >Detail order #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
      <v-btn @click="dialogToggle" dark color="primary">
        <v-icon color="black">chat_bubble</v-icon>
      </v-btn>
      <v-btn
        dark
        color="red"
        @click="toCancelOrder()"
        :loading="canceling_order"
        :disabled="
          canceling_order ||
          (order_status_id == 6 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_status_id == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_detail.order_status == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          isEditOrder ||
          $route.name == 'OrderDetailFood'
        "
        >ยกเลิกออเดอร์</v-btn
      >
    </v-toolbar>
    <v-card class="mt-2">
      <v-layout row wrap>
        <v-flex sm6 xs12>
          <v-card-text>
            <transferInformation
              :order_time="order_time"
              :order_date="order_date"
              :order_end_time="order_end_time"
              :order_end_date="order_end_date"
              :transfer_time="transfer_time"
              :transfer_date="transfer_date"
              :order_detail="order_detail"
              @viewIMG="viewImage($event)"
              @setOrderDate="order_date = $event"
              @setOrderTime="order_time = $event"
            />
          </v-card-text>
        </v-flex>
        <v-flex sm6 xs12>
          <v-card-text>
            <customer-information
              @fetchAddress="fetchAddress()"
              :loading="loading"
              :statusBtn="statusBtn"
              :order_detail="order_detail"
              @viewIMG="viewImage($event)"
            />
          </v-card-text>
          <v-card-text>
            <chatlog
              :statusBtn="statusBtn"
              :openDialogChat="openDialogChat"
              :order_detail="order_detail"
              :provinceData="provinceData"
              @toggleDialogChat="toggleDialogChat"
            />
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-layout column>
          <v-flex>
            <v-btn
              block
              round
              color="primary"
              class="black--text"
              :disabled="
                update_btn ||
                update_loading == 1 ||
                isEditOrder ||
                order_detail.order_status == 7
              "
              @click="updateData()"
              >update</v-btn
            >
          </v-flex>
          <v-flex>
            <div transition="fade">
              <v-icon color="green" v-if="update_loading == 2">check</v-icon>
              <v-icon color="red" v-if="update_loading == 3">close</v-icon>
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="grey"
                v-if="update_loading == 1"
              ></v-progress-circular>
              {{
                update_loading == 1
                  ? "Updating"
                  : update_loading == 2
                  ? "Update successfully"
                  : update_loading == 3
                  ? "Cant update"
                  : null
              }}
            </div>
          </v-flex>
        </v-layout>
        <v-spacer />
      </v-card-actions>
      <v-divider />
    </v-card>
    <v-card class="pb-3">
      <orderDetailProductList @cloneOrder="cloneOrder()" />
    </v-card>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mt-3">
          <v-card-text>
            <rider-information
              :isDisableRider="isDisableRider"
              @cloneOrder="cloneOrder()"
              :order_detail="order_detail"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <orderLog class="mt-3" :order_detail="order_detail" />
    <imageDialog
      :place_name="place_name"
      :view_img_position="view_img_position"
      :dialog="imageDialog"
      @dialog="imageDialog = $event"
    />
    <v-dialog v-model="cancelDialog" persistent max-width="300px">
      <v-card
        ><v-card-title style="background-color: #212121"
          ><h3 style="color: white">Why do you want to cancel ?</h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              cancelDialog = false;
              cancelRemark = '';
            "
          >
            <v-icon color="white">close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCancel">
            <v-text-field
              label="Reason"
              v-model="cancelRemark"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  v.replace(/\ /g, '').replace(/\-/g, '') != '' ||
                  'No symbol only',
              ]"
            ></v-text-field></v-form
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" style="color: #212121" @click="cancelOrder()"
            >submit</v-btn
          ></v-card-actions
        ></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import chatlog from "../OrderOnline/OrderDetail/Chat";
import customerInformation from "./OrderDetail/CustomerInformation.vue";
import riderInformation from "./OrderDetail/RiderInformation.vue";
import orderLog from "./OrderDetail/OrderLog.vue";
import transferInformation from "./OrderDetail/TransferInformation.vue";
import orderDetailProductList from "./OrderDetailProductList";
import filterCustomerForm from "./FilterCustomerForm";
import imageDialog from "./ImageDialog";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_id"],
  components: {
    chatlog,
    customerInformation,
    riderInformation,
    orderLog,
    transferInformation,
    orderDetailProductList,
    filterCustomerForm,
    imageDialog,
  },
  data() {
    return {
      statusBtn: "",
      openDialogChat: false,
      original_data: {},
      canceling_order: false,
      update_loading: 0,
      loading: false,
      original_transfer_time: [],
      original_transfer_date: [],
      transfer_time: [],
      transfer_date: [],
      original_order_time: {},
      original_order_date: {},
      order_time: { value: { HH: "", mm: "" } },
      order_date: { value: null },
      original_order_end_time: {},
      original_order_end_date: {},
      order_end_time: { value: { HH: "", mm: "" } },
      order_end_date: { value: null },
      place_name: null,
      view_img_position: null,
      place: 2,
      imageDialog: false,
      filterDialog: false,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      transfer_note: "",
      order_note: "",
      update_btn_disable: true,
      timeOutEnableRider: 0,
      isDisableRider: true,
      cancelRemark: "",
      cancelDialog: false,
    };
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
      order_detail: (state) => state.fetchOrderDetailBack.order_detail,
      sub_district_list: (state) => state.fetchProvinceBack.sub_district_list,
      order_count_old: (state) => state.fetchOrderListBack.order_count_old,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    update_btn() {
      this.update_btn_disable = this.unSavedData();
      return this.update_btn_disable;
    },
    timeToEnableRider() {
      var date1 = new Date();
      var date2 = new Date(this.order_detail.order_time_start);
      var diff = 10 * 1000 + 2 * 60 * 1000 + date2.getTime() - date1.getTime();
      var msec = diff;
      var hh = Math.floor(msec / 1000 / 60 / 60);
      msec -= hh * 1000 * 60 * 60;
      var mm = Math.floor(msec / 1000 / 60);
      msec -= mm * 1000 * 60;
      var ss = Math.floor(msec / 1000);
      msec -= ss * 1000;
      return hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000 > 0
        ? hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000
        : 0;
    },
  },
  watch: {
    order_detail() {
      if (
        Object.keys(this.order_detail).length != 0 &&
        this.order_detail.constructor === Object
      ) {
        this.setTime();
      }
      clearTimeout(this.timeOutEnableRider);
      let vm = this;
      this.isDisableRider = true;
      console.log(this.timeToEnableRider);
      this.timeOutEnableRider = setTimeout(function () {
        vm.isDisableRider = false;
      }, this.timeToEnableRider);
    },
  },
  methods: {
    toggleDialogChat(value) {
      this.openDialogChat = !value;
    },
    dialogToggle() {
      this.openDialogChat = !this.openDialogChat;
      this.statusBtn = "order_detail";
    },
    cloneOrder() {
      this.original_data = JSON.parse(JSON.stringify(this.order_detail));
    },
    unSavedData() {
      if (
        (JSON.stringify(this.original_data) !=
          JSON.stringify(this.order_detail) ||
          JSON.stringify(this.original_transfer_time) !=
            JSON.stringify(this.transfer_time) ||
          JSON.stringify(this.original_transfer_date) !=
            JSON.stringify(this.transfer_date) ||
          JSON.stringify(this.original_order_time) !=
            JSON.stringify(this.order_time) ||
          JSON.stringify(this.original_order_date) !=
            JSON.stringify(this.order_date) ||
          JSON.stringify(this.original_order_end_time) !=
            JSON.stringify(this.order_end_time) ||
          JSON.stringify(this.original_order_end_date) !=
            JSON.stringify(this.order_end_date)) &&
        this.loading == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    toCancelOrder() {
      let isUnsavedData = !this.unSavedData();
      if (isUnsavedData == true) {
        alert("ข้อมูลมีการเปลี่ยนแปลง กรุณาอัพเดทก่อน");
      } else {
        this.cancelDialog = true;
        this.cancelRemark = "";
      }
    },
    async cancelOrder() {
      if (!this.$refs.formCancel.validate()) return;
      this.cancelDialog = false;
      this.canceling_order = true;
      let form = {
        order_id: this.order_detail.order_id,
        order_note:
          this.order_detail.order_note +
          " เหตุผลที่ยกเลิก: " +
          this.cancelRemark,
      };

      let check = await this.$store.dispatch(
        "fetchOrderListBack/cancelOrder",
        form
      );
      this.canceling_order = false;
      if (check == 2) {
        this.$emit("backListTable", "orderListTable");
        this.$emit("setPagename", true);
      }
    },
    setTime() {
      this.transfer_date = [];
      this.transfer_time = [];
      this.order_time = { value: { HH: "", mm: "" } };
      this.order_date = { value: null };
      this.order_end_time = { value: { HH: "", mm: "" } };
      this.order_end_date = { value: null };

      if (this.order_detail.order_time_start) {
        this.order_date.value = this.order_detail.order_time_start.substring(
          0,
          10
        );
        this.order_time.value = {
          HH: this.order_detail.order_time_start.substring(11, 13),
          mm: this.order_detail.order_time_start.substring(14, 16),
        };
      }
      this.original_order_time = JSON.parse(JSON.stringify(this.order_time));
      this.original_order_date = JSON.parse(JSON.stringify(this.order_date));
      if (this.order_detail.order_time_end) {
        this.order_end_date.value = this.order_detail.order_time_end.substring(
          0,
          10
        );
        this.order_end_time.value = {
          HH: this.order_detail.order_time_end.substring(11, 13),
          mm: this.order_detail.order_time_end.substring(14, 16),
        };
      }

      this.original_order_end_time = JSON.parse(
        JSON.stringify(this.order_end_time)
      );
      this.original_order_end_date = JSON.parse(
        JSON.stringify(this.order_end_date)
      );

      for (let info of this.order_detail.order_store) {
        if (info.store_order_time_end != null) {
          this.transfer_date.push({
            store_id: info.store_id,
            date: info.store_order_time_end.substring(0, 10),
          });
          this.transfer_time.push({
            HH: info.store_order_time_end.substring(11, 13),
            mm: info.store_order_time_end.substring(14, 16),
          });
        } else {
          this.transfer_date.push({ store_id: info.store_id, date: null });
          this.transfer_time.push({ HH: "", mm: "" });
        }
      }
      this.original_transfer_time = JSON.parse(
        JSON.stringify(this.transfer_time)
      );

      this.original_transfer_date = JSON.parse(
        JSON.stringify(this.transfer_date)
      );
    },
    async updateData() {
      for (let val of this.sub_district_list) {
        if (
          this.order_detail.order_customer_address
            .customer_address_sub_district_id == val.sub_district_id
        ) {
          this.order_detail.order_customer_address_zone =
            val.sub_district_name_th;
        }
      }
      this.update_loading = 1;
      if (
        this.order_date.value &&
        this.order_time.value.HH &&
        this.order_time.value.mm
      ) {
        this.order_detail.order_time_start =
          this.order_date.value +
          "T" +
          this.order_time.value.HH +
          ":" +
          this.order_time.value.mm +
          ":00";
      }
      if (
        this.order_end_date.value &&
        this.order_end_time.value.HH &&
        this.order_end_time.value.mm
      ) {
        this.order_detail.order_time_end =
          this.order_end_date.value +
          "T" +
          this.order_end_time.value.HH +
          ":" +
          this.order_end_time.value.mm +
          ":00";
      }
      for (let val of this.order_detail.order_store) {
        let index = this.order_detail.order_store.indexOf(val);
        if (
          this.transfer_date[index].date == null ||
          this.transfer_time[index].HH == "" ||
          this.transfer_time[index].mm == ""
        ) {
          val.store_order_time_end = null;
        } else {
          val.store_order_time_end =
            this.transfer_date[index].date +
            "T" +
            this.transfer_time[index].HH +
            ":" +
            this.transfer_time[index].mm +
            ":00";
        }
      }

      let form = {
        order_id: this.order_detail.order_id,
        order_type: this.order_detail.order_type,
        order_code: this.order_detail.order_code,
        order_customer_id: this.order_detail.order_customer_id,
        order_customer_full_name: this.order_detail.order_customer_full_name,
        order_customer_address_id: this.order_detail.order_customer_address_id,
        order_payment_type: this.order_detail.order_payment_type,
        order_is_paymented: this.order_detail.order_is_paymented,
        order_note: this.order_detail.order_note,
        order_status: this.order_detail.order_status,
        order_store: this.order_detail.order_store,
        order_transfer_note: this.order_detail.order_transfer_note,
        order_customer: this.order_detail.order_customer,
        order_customer_address: this.order_detail.order_customer_address,
        order_time_start: this.order_detail.order_time_start,
        order_time_end: this.order_detail.order_time_end,
      };
      this.update_loading = await this.$store.dispatch(
        "fetchOrderDetailBack/updateOrder",
        form
      );
      if (this.update_loading == 2) {
        this.setTime();
        this.original_data = JSON.parse(JSON.stringify(this.order_detail));
      }
      if (this.update_loading == 2 && this.order_detail.order_status == 6) {
        this.backToList();
      }
      this.getCountOrder();
    },
    async getNewDataList() {
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
    },
    async getCountOrder() {
      let check_res = await this.$store.dispatch(
        "fetchOrderListBack/getCountOrder"
      );
      if (JSON.stringify(check_res) != JSON.stringify(this.order_count_old)) {
        this.getNewDataList();
        this.$store.commit("fetchOrderListBack/getOldCountOrder", check_res);
      }
    },
    viewImage(data) {
      this.imageDialog = true;
      this.view_img_position = data.img;
      this.place_name = data.place_name;
    },
    backToList() {
      if (this.$route.params.orderid && this.$route.name == "OrderDetailFood") {
        this.$router.push({
          path:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/report/order_report",
        });
      } else {
        let isUnsavedData = !this.unSavedData();
        if (isUnsavedData == true) {
          confirm("คุณต้องการละทิ้งการเปลี่ยนแปลงหรือไม่ ? ") &&
            this.$emit("backListTable", "orderListTable");
        } else {
          this.getBack();
        }
      }
    },
    getBack() {
      this.$emit("backListTable", "orderListTable");
      this.$emit("setPagename", true);
    },
    async fetchAddress() {
      this.$store.dispatch("fetchProvinceBack/getProvinceList");
      this.$store.dispatch(
        "fetchProvinceBack/getDistrictList",
        this.order_detail.order_customer_address.customer_address_province_id
      );
      this.$store.dispatch(
        "fetchProvinceBack/getZipCodeList",
        this.order_detail.order_customer_address.customer_address_district_id
      );
      await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictList",
        this.order_detail.order_customer_address.customer_address_district_id
      );
    },
    async fetchData() {
      this.loading = true;
      let fetch_check = await this.$store.dispatch(
        "fetchOrderDetailBack/getOrderDetail",
        this.order_id
      );
      if (fetch_check != false) {
        this.$store.dispatch(
          "fetchCustomerBack/getCustomerAddressList",
          this.order_detail.order_customer_id
        );
        // await this.fetchAddress();
      }
      this.loading = false;
      // this.setTime();
    },
  },
  async created() {
    if (this.$route.params.orderid && this.$route.name == "OrderDetailFood") {
      this.$store.commit("fetchOrderListBack/setOrderStatusID", 6);
    }
    await this.fetchData();

    this.original_data = JSON.parse(JSON.stringify(this.order_detail)); // forUnsavedData
  },
};
</script>

<style>
.time-picker input.display-time {
  border: none;
}
</style>
